import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

/**
 * Contrato de leitura do motor de estados (mapa de ocupação — semáforo).
 * GET {culture}/api/StationState — anônimo, envelope { success, data }.
 * O ApiHandler injeta o prefixo /{lang}/api automaticamente.
 * Usado para o paint inicial e como fallback do hub SignalR (AC-5).
 */
export default class StationStateApi {
  static async GetStationState(): Promise<any> {
    return ApiHandler(baseURL).get("/StationState");
  }
}

/**
 * URL do hub SignalR de tempo real (/hubs/station-state).
 *
 * O hub fica FORA do prefixo {culture}/api (o payload não tem texto localizado),
 * então é montado direto sobre a base da API — não pelo ApiHandler. Se a base vier
 * vazia (dev usando proxy relativo), o caminho relativo /hubs/station-state é
 * redirecionado pelo setupProxy (regra /hubs com ws:true).
 */
export const getStationStateHubUrl = (): string => {
  const base = (getUrlApi() || "").toString().replace(/\/+$/, "");
  return `${base}/hubs/station-state`;
};
